import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useInsertData } from "../../hooks/useInsertData";
import { useGetData } from "../../hooks/useGetData";
import { useUpdateData } from "../../hooks/useUpdateDate";
import useDeleteData from "../../hooks/useDeleteData";

export const createBranch = createAsyncThunk("branch/createBranch", async (data, { rejectWithValue }) => {
  try {
    const res = await useInsertData("branches", data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

export const getAllBranches = createAsyncThunk("branch/getAllBranches", async (_, { rejectWithValue }) => {
  try {
    const res = await useGetData("branches");
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const getBranchById = createAsyncThunk("branch/getBranchById", async (id, { rejectWithValue }) => {
  try {
    const res = await useGetData(`branches/${id}`);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const updateBranch = createAsyncThunk("branch/updateBranch", async ({ data, id }, { rejectWithValue }) => {
  try {
    const res = await useUpdateData(`branches/${id}`, data);
    return res.data;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});
export const deleteBranch = createAsyncThunk("branch/deleteBranch", async (id, { rejectWithValue }) => {
  try {
    const res = await useDeleteData(`branches/force/${id}`);
    return id;
  } catch (err) {
    if (err.response && err.response.data) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err.message);
  }
});

const initialState = {
  branch: null,
  allBranches: null,
  detailsBranch: null,
  status: "idle",
  error: null,
};
export const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createBranch.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createBranch.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.branch = action.payload;
      })
      .addCase(createBranch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getAllBranches.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllBranches.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allBranches = action.payload;
      })
      .addCase(getAllBranches.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(getBranchById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getBranchById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.detailsBranch = action.payload;
      })
      .addCase(getBranchById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // //---------------------------------------
      .addCase(deleteBranch.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allBranches = state.allBranches?.filter((branch) => branch.id !== action.payload);
      })
      .addCase(deleteBranch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
    // //---------------------------------------
    // .addCase(resendCode.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resendCode.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resendCodeResponse = action.payload;
    // })
    // .addCase(resendCode.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(loginUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(loginUser.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.currentUser = action.payload.data;
    //   state.token = action.payload.token;
    // })
    // .addCase(loginUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(getCurrentUser.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(getCurrentUser.fulfilled, (state, action) => {
    //   state.currentUser = action.payload.user;
    //   state.status = "succeeded";
    // })
    // .addCase(getCurrentUser.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(forgetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(forgetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.forgetPasswordResponse = action.payload;
    // })
    // .addCase(forgetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(resetPassword.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(resetPassword.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.resetPasswordResponse = action.payload;
    // })
    // .addCase(resetPassword.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // })
    // //---------------------------------------
    // .addCase(updateUserData.pending, (state) => {
    //   state.status = "loading";
    //   state.error = null;
    // })
    // .addCase(updateUserData.fulfilled, (state, action) => {
    //   state.status = "succeeded";
    //   state.user = action.payload;
    // })
    // .addCase(updateUserData.rejected, (state, action) => {
    //   state.status = "failed";
    //   state.error = action.payload;
    // });
  },
});
export default branchSlice.reducer;
